import React, { Component } from 'react';
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CircularProgress } from 'material-ui/Progress';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';

import DataTable from './datatable';

import PageSubHeader from '../../pagesubheader'
import ContainerHeader from '../../../components/ContainerHeader/index';
import * as userdetails from '../../../actions/userdetails';

class PendingApproval extends Component {

    constructor(props) {
        super(props)
        this.state = {
            filterText: '',
        }
    }
    componentDidMount() {
        // console.log('props', this.props)
        this.props.actions.resetUser();
        this.props.actions.getPendingApprovalList();
    }

    handleUserInput(filterText) {
        this.setState({ filterText: filterText });
    };
    render() {
        const { userDetails, match, loginUser } = this.props;

        let dataList = <tr><td></td></tr>;
        let message = null;
        // console.log('userDetails', userDetails);
        if (userDetails && userDetails.Status) {
            message = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        else if (userDetails && userDetails.UserdetailsList && userDetails.UserdetailsList.length > 0) {
            // dataList = userDetails.UserdetailsList.map((_data, index) => {
            //     return (<TableCell key={index} data={_data} index={index} />);
            // })
        }

        return (
            <div className="slideInUpTiny ">
                {message}
                <ContainerHeader title="Pending User List" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12">
                        <div className="row">
                            {/* <PageSubHeader committee_id={this.state.committee_id} 
                                teamDetails={null}
                                onUserInput={this.handleUserInput.bind(this)} /> */}
                            <div className="col-12">
                                <DataTable
                                    data={userDetails && userDetails.UserdetailsList && userDetails.UserdetailsList.length > 0 ? userDetails.UserdetailsList : null}
                                    filterText={this.state.filterText} />
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

function mapStateToProps(state, ownProps) {
    // console.log('state=>', state)
    const { userDetails } = state
    const { match } = ownProps
    return { userDetails, match }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(userdetails, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(PendingApproval);


// WEBPACK FOOTER //
// ./app/userdetails/pendingapproval/index.js